import { action } from 'satcheljs/lib/legacy';
import { TableView } from 'owa-mail-list-store';
import { clearTableViewLastEmptiedTimeInStore } from '../mutators/clearTableViewLastEmptiedTimeMutator';

export default action('clearTableViewLastEmptiedTime')(function clearTableViewLastEmptiedTime(
    tableView: TableView
) {
    clearTableViewLastEmptiedTimeInStore(tableView.serverFolderId);
});
